import { render, staticRenderFns } from "./LicenseSlotsConfiguration.vue?vue&type=template&id=50e11d9a&scoped=true&"
import script from "./LicenseSlotsConfiguration.vue?vue&type=script&lang=ts&"
export * from "./LicenseSlotsConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e11d9a",
  null
  
)

export default component.exports